import { Chip, ChipProps } from '@mui/material'
import { RequestStatus } from '../enums/RequestStatus'
import { useTranslation } from 'react-i18next'
import { Priority } from '../enums'

export interface ActionRequestPriorityChipProps extends Omit<ChipProps, 'label' | 'color'> {
  priority: Priority
}

export default function ActionRequestPriorityChip({
  priority,
  ...props
}: ActionRequestPriorityChipProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * The color of the chip.
   */
  let color: ChipProps['color']
  switch (priority) {
    case Priority.LOW:
      color = 'info'
      break
    case Priority.MEDIUM:
      color = 'warning'
      break
    case Priority.HIGH:
      color = 'error'
      break
    case Priority.CRITICAL:
      color = 'error'
      break
    default:
      color = 'info'
      break
  }

  /**
   * The label of the chip.
   */
  const label = t(`RequestPriority.${priority}`)

  return <Chip label={label} color={color} {...props} />
}
